import { configureAWSCredentialsWithToken } from './configureAWSCredentialsWithToken';
import { LatLong, suggestPois } from './suggestPois';

export const searchForLocationSuggestions = async (
  searchTerm: string,
  currentToken: string,
  bias?: LatLong
) => {
  await configureAWSCredentialsWithToken(currentToken);
  return suggestPois(searchTerm, bias);
};
